/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBuilder = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M7.16 2.486 19.675 7H22v2h-3v1h1v2h-1v1.17A3.001 3.001 0 1 1 15 16h2a1 1 0 1 0 1-1h-1v-3h-1v-2h1V9h-6v11h2v2H2v-2h2V9H2.034L7.16 2.486zM6 9v11h3V9H6zm7.78-2L7.84 4.857 6.153 7h7.627z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBuilder as Builder };
